import { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import NotificationCenter from './NotificationCenter';

const NotificationCenterPage = ({ user }) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const fetchNotifications = async () => {
      const { data, error } = await supabase
        .from('notifications')
        .select('*')
        .eq('user_id', user.id)
        .order('created_at', { ascending: false });

      if (!error) setNotifications(data);
    };

    fetchNotifications();

    const markAllAsRead = async () => {
      await supabase
        .from('notifications')
        .update({ is_read: true })
        .eq('user_id', user.id)
        .eq('is_read', false);
    };

    markAllAsRead();
  }, [user.id]);

  return (
    <div className="notification-page">
      <h2>Your Notifications</h2>
      <NotificationCenter userId={user.id} showAll={true} />
      <div className="notification-list">
        {notifications.length === 0 ? (
          <p>No notifications yet</p>
        ) : (
          notifications.map(notification => (
            <div 
              key={notification.id} 
              className={`notification ${!notification.is_read ? 'unread' : ''}`}
            >
              <h4>{notification.title}</h4>
              <p>{notification.message}</p>
              <small>
                {new Date(notification.created_at).toLocaleString()}
              </small>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationCenterPage;